// NATIVE 
import * as React from 'react';



// INSTALLED 
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';



// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { storeCreateArea } from '../../../store/areas';
import MultipleSnackbars from '../../MultipleSnackbars';
import { CreateArea } from '../../areas/crear/CreateArea';
import { closeSessionGlobal } from '../../../commons/utils';
import { timeToClosedToast } from '../../../commons/values';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import validationSchema from '../../areas/formModels/crear/validationSchema';
import formInitialValues from '../../areas/formModels/crear/formInitialValues';
import createAreaFormModel from '../../areas/formModels/crear/createAreaFormModel';





const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





/**
 * DialogArea component is a modal dialog used for creating an area or department.
 * It utilizes Formik for form handling and validation, and Redux for state management.
 * 
 * @param {object} props - The properties passed to the component.
 * @param {boolean} props.open - Determines if the modal is open or closed.
 * @param {function} props.handleCloseModalCrear - Function to handle closing the modal.
 * 
 * @returns {JSX.Element} The rendered DialogArea component.
 * 
 * @component
 * 
 * @example
 * <DialogArea open={true} handleCloseModalCrear={handleClose} />
 * 
 * @remarks
 * This component includes several state hooks for managing alert messages, form submission status, and modal visibility.
 * It also dispatches actions to the Redux store for creating an area.
 * 
 * @requires useDispatch - Redux hook for dispatching actions.
 * @requires React.useState - React hook for managing local component state.
 * @requires Formik - Formik component for form handling.
 * @requires validationSchema - Validation schema for form validation.
 * @requires createAreaFormModel - Model containing form ID and fields.
 * @requires storeCreateArea - Redux action for creating an area.
 * @requires ModalSessionExpired - Component for displaying session expired modal.
 * @requires MultipleSnackbars - Component for displaying multiple snackbars.
 * @requires SnackAlert - Component for displaying a single snackbar alert.
 * @requires BootstrapDialog - Custom dialog component.
 * @requires DialogTitle - Dialog title component.
 * @requires IconButton - Icon button component.
 * @requires CloseIcon - Icon for the close button.
 * @requires DialogContent - Dialog content component.
 * @requires DialogActions - Dialog actions component.
 * @requires Grid - Grid component for layout.
 * @requires CreateArea - Component for rendering the form fields.
 * @requires Button - Button component for form submission.
 */
export const DialogArea = (props:any) =>  {

  
  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [txtBtnEditArea, setTxtBtnEditArea] = React.useState<string>('Crear Area');

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  // PROPS 
  const{ open, handleCloseModalCrear } = props;

  
  // DATA MODELS 
  const { formId, formField } = createAreaFormModel;
  const currentValidationSchema = validationSchema[0];


  //  USE EFFECT 
  React.useEffect(() => {
      setIsSubmiting(!open);
  }, [props]);

   
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalCrear(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {


    setTxtBtnEditArea('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const response = await dispatch( storeCreateArea(values, setPercentajeArea) );

   await setTxtBtnEditArea('Crear Area')

   const result =  await validateResponseCreate(response, ' ( Crear Area ) ')

   if ( response.code == 409) {
       setIsSubmiting(false);
   }
   

   if (!result) {
       return false;
   }

   setIsSubmiting(false);


    if (response.ok) {

      const errors:any = {
        msg: 'Area Creada Con Exito',
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);


      actions.setSubmitting(false);
      handleCloseModalCrear(false);
    }

  
  }

  const validateResponseCreate = async(response:any, textActionConcat: string) => {
    
    
            if (  response.code == 401  ) {
              await localStorage.removeItem('lastSelectedQypht');
              await closeSessionGlobal();
              await handleCloseModalCrear(false);
              setModalSessionExpired(true);
              return false;
            }
    
         
            // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
            if (!response.ok && response.code == 403 ) { 
    
              const errors:any = {
                  msg: response.errors[0]+' '+textActionConcat,
                  status: 'error'
              };
              
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
              return false;
            }


            // 403 EL DATO YA SE ENCUENTRA REGISTRADO
            if (!response.ok && response.code == 409 ) { 
    
              const errors:any = {
                  msg: response.errors+' '+textActionConcat,
                  status: 'error'
              };
              
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
              return false;
            }
    
            
            // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
            if (!response.ok && response.code == 400 ) { 
       
              const errors:any = [];
    
              response.errors.forEach( (element:any) => {
                  
                  errors.push({
                    type: 'error',
                    text: element
                  });
              });
    
                
              setMessagesAlerts(errors);
              return false;
    
            }
    
            return true;
          
  }

  return (
    <React.Fragment>


      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear Area o Departamento
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <CreateArea formField={formField}/>

                <Button
                    disabled={isSubmiting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      txtBtnEditArea
                    }
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}